import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";
import { getInvoicesFileList } from "../../../service/bankApi/getInvoicesFilesList";
import { useDispatch, useSelector } from "react-redux";

import { processFileApi } from "../../../service/bankApi/processFile";
import { toast } from "react-toastify";
import ResponceForAPI from "../../components/backdrop/backdropLoader";
import UploadInvoicesTable from "./uploadedInvoicesTable";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import ProcessedTable from "./processedTable";
import { getProcessedInvoiceDataByIdApi } from "../../../service/bankApi/getProcessedInvoicesById";
import { deleteInvoiceFileByIdApi } from "../../../service/bankApi/deleteInvoiceById";
import { setLoading } from "../../../feature/authSlice";
import { redirectToDash } from "../redirectToDash";
import { findSubMenuByName } from "../propertyList/MenuUtlis";
const UploadedInvoices = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filesArrayRec, setFilesArrRec] = useState([]);
  const [fileArrProcessed, setFileArrProcessed] = useState([]);
  const [openTab, setOpenTab] = useState(1);

  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [apiloading, setApiLoading] = useState(false);
  const { permissions } = useSelector((state) => state.permissionsData);
  const [pageProcessed, setPageProcessed] = React.useState(1);
  const [pageSizeProcessed, setPageSizeProcessed] = useState(10);
  const [totalPageProcessed, setTotalPageProcessed] = useState(1);
  const [searchValueProcessed, setSearchValueProcessed] = useState("");
  const [totalNoRecordProcessed, setTotalNoRecordProcessed] = useState(100);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const columns = [
    {
      Header: "File Name",
      Footer: "File Name",
      accessor: "FileName",
    },
    {
      Header: "Timestamp",
      Footer: "Timestamp",
      accessor: "UploadedAt",
    },
    {
      Header: "Uploaded By",
      Footer: "Uploaded By",
      accessor: "UploadedBy",
    },
    {
      Header: "Action",
      Footer: "Action",
      accessor: "action",
    },
  ];

  const [deleteId,setDeleteId] = useState()
  useEffect(() => {
    setApiLoading(true);
    onLoadData()
    
  }, [
    searchValue,
    pageSize,
    page,
    openTab,
    searchValueProcessed,
    pageSizeProcessed,
    pageProcessed,
  ]);

  function onLoadData() {
    if (openTab === 1) {
      var data = {
        Filter: "status==0",
        OrderBy: "-Id",
        PageSize: pageSize,
        PageNumber: page,
      };

      dispatch(
        getInvoicesFileList(
          data,
          (res) => {
            setApiLoading(false);
            
            setFilesArrRec(res?.data?.result?.Invoices);
            if (parseInt(res?.data?.result?.TotalCount) % pageSize === 0) {
              setTotalPage(parseInt(res?.data?.result?.TotalCount / pageSize));
            } else {
              setTotalPage(
                parseInt(res?.data?.result?.TotalCount / pageSize + 1)
              );
            }
          },
          (err) => {
            
            setApiLoading(false);
            setFilesArrRec([]);
            console.log(err);
          }
        )
      );
    } else if (openTab == 2) {
      var data = {
        Filter: "status==1",
        OrderBy: "-Id",
        PageSize: pageSizeProcessed,
        PageNumber: pageProcessed,
      };

      dispatch(
        getInvoicesFileList(
          data,
          (res) => {
            setApiLoading(false);
            
            setFileArrProcessed(res?.data?.result?.Invoices);
            if (parseInt(res?.data?.result?.TotalCount) % pageSize === 0) {
              setTotalPageProcessed(
                parseInt(res?.data?.result?.TotalCount / pageSize)
              );
            } else {
              setTotalPageProcessed(
                parseInt(res?.data?.result?.TotalCount / pageSize + 1)
              );
            }
          },
          (err) => {
            setApiLoading(false);
            
            setFileArrProcessed([]);
            console.log(err);
          }
        )
      );
    }
  }
  const notifyTopRight = () => {
    toast.success("✔️ Approved Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const notifyTopRightDelete =()=>{
    toast.success("Deleted Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }
  
  const handleVerify = (id) => {
    
    console.log(id,"Value")
    setApiLoading(true);
    // var data = {
    //   fileId: id,
    // };
    dispatch(
      processFileApi(
        id,
        (res) => {
          setApiLoading(false);
          
          localStorage.setItem("invoiceId",id)
          // notifyTopRight();
          localStorage.setItem(
            "verifyObject",
            JSON.stringify(res?.data?.result)
          );
          navigate("/verificationScreen");
          console.log(res.data.result);
        },
        (err) => {
          
          setApiLoading(false);
          console.log(err);
        }
      )
    );
  };

  const handleSearch = (e) => {
    // setPage(1)

    setSearchValue(e.target.value);
    if (searchValue.trim().length >= 2) {
      onChangePage(1);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };

  const handleVerifyProcessed = (id) => {
    
  };

  const handleSearchProcessed = (e) => {
    // setPage(1)

    setSearchValueProcessed(e.target.value);
    if (searchValueProcessed.trim().length >= 2) {
      onChangePageProcessed(1);
    }
  };

  const handleChangeRowsPerPageProcessed = (e) => {
    // console.log(e)
    setSearchValueProcessed("");
    setPageProcessed(1);
    setPageSizeProcessed(e.target.value);
  };

  const onChangePageProcessed = (e, p) => {
    // setPage(p);
    setPageProcessed(e);
  };

  const handleViewProcessedInvoice = (id) =>{
    
    localStorage.setItem("processedFileId", id)
    const data = {
        fileId:id
    };
    dispatch(
      getProcessedInvoiceDataByIdApi(
        data,
        (res) => {
            localStorage.setItem(
                "verifyObject",
                JSON.stringify(res?.data?.result)
              );
              
              navigate("/verificationScreen");
        },
        () => {}
      )
    );
   
  }

  const handleDeleteById = ( id)=>{
setDeleteId(id)
setDeleteModalStatus(true)

  }

  function handleDeleteConfirm (){
  var data = {
    fileId:deleteId
  }
  dispatch(deleteInvoiceFileByIdApi(data,(res)=>{
    onLoadData()
    
    setDeleteModalStatus(false)
    notifyTopRightDelete()
  
  },(err)=>{
    
  }))
  }


 
  // Helper function to find the "List Property" submenu within "Properties"
  const findListPropertySubMenus = () => {
    const propertiesMenu = permissions?.find(menu => menu.MenuItemName === 'Invoice');
    if (!propertiesMenu) return [];

    const listPropertySubMenu = propertiesMenu.SubMenus.find(subMenu => subMenu.MenuItemName === 'Invoice Verification');
    if (!listPropertySubMenu) return [];

    return listPropertySubMenu.SubMenus;
  };

  // Get the submenus of "List Property"
  const listPropertySubMenus = findListPropertySubMenus();

  const handleTab = (eventKey) => {
    switch (eventKey) {
      case 'Pending':
        setOpenTab(1);
        break;
      case 'Processed':
        setOpenTab(2);
        break;
      default:
        console.log('Default tab action');
        break;
    }
  };  
    // Find the "List Property" submenu under "Properties"
    const propertiesMenu = findSubMenuByName(permissions, 'Invoice');
    const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu.SubMenus, 'Invoice Verification') : null;

    useEffect(() => {
      if(!listPropertyMenu){
        redirectToDash(navigate,toast)
      }
    }, [])
    
  return (
    <>
      {/* <ResponceForAPI show={apiloading} /> */}

      <div className="row">
        <div className="col-xxl-12">
          <div className="card">
            <Tab.Container defaultActiveKey="Pending">
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="heading me-2">Invoice Verification</h4>
                <nav>
                  <Nav as="div" className="order nav nav-tabs" role="tablist">
                  {listPropertySubMenus.map(subMenu => (
        <Nav.Link
          key={subMenu.MenuItemId}
          as="button"
          eventKey={subMenu.MenuItemName}
          onClick={() => handleTab(subMenu.MenuItemName)} // Replace handleTab with your logic
        >
          {subMenu.MenuItemName}
        </Nav.Link>
      ))}
                    {/* <Nav.Link
                      as="button"
                      eventKey="pending"
                      onClick={() => {
                        setOpenTab(1);
                      }}
                    >
                      Pending
                    </Nav.Link>
                    <Nav.Link
                      as="button"
                      eventKey="Processed"
                      onClick={() => {
                        setOpenTab(2);
                      }}
                    >
                      Processed
                    </Nav.Link> */}
                  </Nav>
                </nav>
              </div>
              <div className="card-body pt-2">
                <Tab.Content>
                  <Tab.Pane eventKey="Pending">
                    <UploadInvoicesTable
                      column={columns}
                      rowsArr={filesArrayRec}
                      handleVerify={handleVerify}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPage
                      }
                      searchValuePagination={searchValue}
                      pageSizePagination={pageSize}
                      handleSearchPagination={handleSearch}
                      totalCountPagination={totalPage}
                      handleOnChangePagination={onChangePage}
                      handleDeleteById={handleDeleteById}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Processed">
                    {" "}
                    <ProcessedTable
                      column={columns}
                      rowsArr={fileArrProcessed}
                      handleVerify={handleVerifyProcessed}
                      handleChangeRowsPerPagePagination={ handleChangeRowsPerPageProcessed}
                      searchValuePagination={searchValueProcessed}
                      pageSizePagination={pageSizeProcessed}
                      handleSearchPagination={handleSearchProcessed}
                      totalCountPagination={totalPageProcessed}
                      handleOnChangePagination={onChangePageProcessed}
                      handleViewProcessedInvoice={handleViewProcessedInvoice}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
      <Modal className="fade" show={deleteModalStatus} centered>
        <Modal.Header>
          <Modal.Title>Alert</Modal.Title>
          <Button
            onClick={() => setDeleteModalStatus(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black"> 
            Are you sure you want to delete this Invoice ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setDeleteModalStatus(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={()=>{handleDeleteConfirm()}}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default UploadedInvoices;
